import {
  apiGetLabelSuggestions,
  type GetLabelSuggestionsRequest,
  type LabelSuggestionAttribution,
} from '../api/memex-items/api-get-label-suggestions'
import {queryClient} from './query-client'

export const labelSuggestionsQueryKey = 'labelSuggestions'

/**
 * Keyed on the repository only. Suggestions are a property of the viewer and the
 * repository, not of any single item, while memex's own suggestion cache is
 * keyed per item. Without this key, opening 30 items in one repository would
 * issue 30 identical requests.
 */
export function buildLabelSuggestionsQueryKey({owner, repo}: GetLabelSuggestionsRequest) {
  return ['memex', labelSuggestionsQueryKey, {owner, repo}] as const
}

/**
 * Suggestions reflect labels applied minutes ago, so they are cheap to
 * revalidate but should not be refetched for every item opened in a burst.
 */
const STALE_TIME_MS = 60_000

export function fetchLabelSuggestions({
  owner,
  repo,
}: GetLabelSuggestionsRequest): Promise<Array<LabelSuggestionAttribution>> {
  return queryClient.fetchQuery({
    queryKey: buildLabelSuggestionsQueryKey({owner, repo}),
    queryFn: () => apiGetLabelSuggestions({owner, repo}),
    staleTime: STALE_TIME_MS,
    // The label list is awaited alongside this request, so a retry would delay
    // the whole picker to re-attempt an optional enhancement. The `memex` query
    // default retries once; suggestions opt out.
    retry: false,
  })
}
